"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCalendarButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledCalendarButton = styled_components_1.default.button `
  background: ${config_1.colors.white};
  border-color: ${config_1.colors.blurple};
  border-radius: 4px;
  color: ${config_1.colors.blurple};
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  height: 40px;
  width: 70px;
`;
